export interface FaqItem {
  id: string
  question: string
  answer: string
  category?: 'general' | 'pricing' | 'technical' | 'privacy' | 'billing'
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: 'faq-1',
    category: 'general',
    question: 'Heinrich는 어떤 서비스인가요?',
    answer:
      'Heinrich(세이프)는 산업안전 업무를 AI로 자동화하는 SaaS입니다. JSA(작업안전분석), TBM(툴박스미팅), 위험성평가, 시정지시서 작성을 자동화하고, 이미지 기반 위험요소 분석, 안전 법령 챗봇, 문서 템플릿 엔진 등 현장 안전관리자의 핵심 업무를 지원합니다.',
  },
  {
    id: 'faq-2',
    category: 'pricing',
    question: '무료 플랜에서 사용할 수 있는 기능은 무엇인가요?',
    answer:
      '무료 플랜에서는 AI 안전 챗봇을 하루 10회, JSA/위험성평가/이미지 분석을 월 5회, TBM·재해조사표를 월 1회, 작업허가서·시정지시서를 월 2회, 안전교육 자료(PPTX)를 월 2회 체험할 수 있습니다(안전교육 영상은 유료 플랜부터). 무료 플랜에는 Google AdSense 광고가 노출됩니다. 더 많은 사용량과 광고 없는 경험은 유료 플랜으로 업그레이드하세요.',
  },
  {
    id: 'faq-3',
    category: 'pricing',
    question: '구독을 언제든지 취소할 수 있나요?',
    answer:
      '네, 언제든지 대시보드 → 구독/결제 메뉴에서 취소할 수 있습니다. 취소 시 해당 결제 주기 종료일까지 서비스가 유지되며, 이후 무료 플랜으로 자동 전환됩니다. 최초 결제 후 7일 이내 미사용 취소 시 전액 환불됩니다.',
  },
  {
    id: 'faq-4',
    category: 'billing',
    question: '결제 방법은 어떻게 되나요?',
    answer:
      '신용카드(KG이니시스) 를 통한 월간 정기 결제(자동 갱신)를 지원합니다. Heinrich는 카드 정보를 직접 보관하지 않으며, 빌링키만 안전하게 저장합니다. 매월 구독 갱신일에 자동으로 결제되며, 실패 시 이메일로 안내드립니다.',
  },
  {
    id: 'faq-5',
    category: 'technical',
    question: 'AI가 생성한 JSA/TBM 결과를 그대로 현장에 적용해도 되나요?',
    answer:
      'AI가 생성한 결과물은 전문가 검토를 위한 초안(Draft)입니다. 산업안전보건법은 위험성평가, JSA 등 안전 문서에 대해 자격 있는 관리자의 서명·확인을 요구합니다. Heinrich의 AI 결과는 업무 효율화를 위한 보조 도구이며, 반드시 안전보건 담당자의 검토·수정 후 사용하세요.',
  },
  {
    id: 'faq-6',
    category: 'technical',
    question: '업로드한 이미지나 문서 데이터는 어떻게 처리되나요?',
    answer:
      '업로드된 데이터는 서비스 제공 목적으로만 사용됩니다. AI 분석 시 Google Cloud(Gemini API)로 프롬프트가 전송될 수 있으며, 이는 개인정보처리방침에 명시되어 있습니다. 사용자는 언제든 본인 데이터 삭제를 요청할 수 있으며, 요청 즉시 삭제 처리 후 30일 백업 주기 내 완전 소각됩니다.',
  },
  {
    id: 'faq-7',
    category: 'privacy',
    question: '소셜 로그인(구글/카카오/네이버) 시 어떤 정보가 공유되나요?',
    answer:
      '소셜 로그인 시 해당 플랫폼이 제공하는 이메일, 닉네임, 프로필 이미지 URL이 수집됩니다. 비밀번호는 수집되지 않습니다. 연동된 계정은 설정 메뉴에서 언제든 해제할 수 있습니다.',
  },
  {
    id: 'faq-8',
    category: 'general',
    question: 'Enterprise 플랜은 어떻게 도입하나요?',
    answer:
      'Enterprise 플랜은 직접 영업 문의를 통해 도입합니다. 맞춤 계약, 전용 온보딩, 전담 지원, 사내 배포 옵션 등을 상담할 수 있습니다. 아래 문의 양식을 작성하시거나 heinrich_dasan@naver.com으로 연락해 주세요.',
  },
  {
    id: 'faq-9',
    category: 'technical',
    question: '모바일에서도 사용할 수 있나요?',
    answer:
      '네, Heinrich는 반응형 웹 앱으로 스마트폰·태블릿에서도 사용 가능합니다. 현장에서 모바일로 사진을 찍어 즉시 이미지 위험분석을 하거나, TBM 진행 시 챗봇으로 안전 체크리스트를 확인할 수 있습니다.',
  },
  {
    id: 'faq-10',
    category: 'pricing',
    question: '자사 양식(엑셀/PDF)은 어떤 플랜에서 쓸 수 있나요?',
    answer:
      '기존 자사 양식 업로드와 AI 필드 매핑은 Business 플랜 이상에서 지원됩니다. 대시보드 → 양식 관리에서 xlsx/docx 파일을 무제한 업로드하면 AI가 자동으로 항목·위험요인·안전조치 컬럼을 인식해 매핑하고, 이후 모든 생성물이 귀사 양식 형식으로 출력됩니다. 다중 사용자 시트가 필요한 경우 Enterprise 플랜을 문의하세요.',
  },
]
